import React from 'react';
import { Slide } from 'react-awesome-reveal';
import { Box, Stack, Typography } from '@mui/material';
import { Fade } from 'react-awesome-reveal';
import './Contact.scss';
import { Link } from 'react-router-dom';
import Navbar from '../navbar/Navbar';
import sectionConstants from '../constants/SectionConstants';
import ContactSection1 from './componenets/ContactSection1';
import Footer from '../footer/FooterSection';

export const Contact = () => {
  return (
    <Box className='contact-page'>
      <Box  id="top" className='contact-image'>
        <Box className='nav-section'>
          <Navbar />
        </Box>
        <Stack className='contact-heading' spacing={2}>
          <Typography className='contact-heading-data1'>
            <Slide>{sectionConstants.ContactUss}</Slide>
          </Typography>
          <Typography className='contact-heading-data2'>
            <Stack direction='row' spacing={1}>
              <Slide>
                {' '}
                <Link to='/'>
                  <Typography className='contact-heading-data2'>
                    {sectionConstants.Home}
                  </Typography>
                </Link>
              </Slide>
              /
              <Slide>
                <Link to='/contact'>
                  <Typography className='contact-heading-data2'>
                    {sectionConstants.ContactUs}
                  </Typography>
                </Link>
              </Slide>
            </Stack>
          </Typography>
        </Stack>
      </Box>
      <ContactSection1 />
      <Footer />
    </Box>
  );
};
